var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelineViewAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 5,
    viewBox: "0 0 7 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88543 2.14537L4.84399 0.113749C4.69108 -0.0384193 4.44375 -0.037853 4.29154 0.115077C4.13936 0.267987 4.13994 0.515311 4.29285 0.667499L5.66325 2.03125H0.390625C0.174883 2.03125 0 2.20613 0 2.42187C0 2.63762 0.174883 2.8125 0.390625 2.8125H5.66323L4.29287 4.17625C4.13996 4.32844 4.13938 4.57576 4.29156 4.72867C4.44377 4.88162 4.69112 4.88215 4.84401 4.73L6.8851 2.69875C7.03809 2.54605 7.03795 2.29756 6.88543 2.14537Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineViewAllIcon);
export default __webpack_public_path__ + "static/media/pipelineViewAllIcon.f5b54da874eabed162dc09de77bf0594.svg";
export { ForwardRef as ReactComponent };